var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("AprobarPermiso"),
      _vm._v(" "),
      _c("AprobarPermisoOficialPorHoras"),
      _vm._v(" "),
      _c("RechazarPermisoOficialPorHoras"),
      _vm._v(" "),
      _c("VerPermisoJefe"),
      _vm._v(" "),
      _c("VerDocumento"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { info: "" } }, [_vm._v("exit_to_app")]),
          _vm._v(
            "Aprobación/Rechazo de\n    permisos-licencias-omisiones superior Jerarquico (Director)\n  "
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "", md6: "" } },
        [
          _c("v-autocomplete", {
            attrs: {
              items: _vm.lista_gestiones,
              "item-text": "periodo",
              "item-value": "periodo",
              label: "Seleccione la gestión",
              required: "",
              outline: "",
              success: "",
              clearable: ""
            },
            on: {
              change: function($event) {
                return _vm.actualizaCrudTable()
              }
            },
            model: {
              value: _vm.periodo_seleccionado,
              callback: function($$v) {
                _vm.periodo_seleccionado = $$v
              },
              expression: "periodo_seleccionado"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _vm.sw_crud_table
                ? _c("crud-table", {
                    staticClass: "tabla-comprimida-light",
                    attrs: {
                      headers: _vm.headers,
                      url: _vm.url,
                      filters: _vm.filters,
                      graphql: _vm.graphql,
                      "data-graphql": _vm.dataGraphql,
                      widthModal: 840,
                      initData: _vm.initData
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "items",
                          fn: function(items) {
                            return [
                              _c("td", [_vm._v(_vm._s(items.item.numero))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(items.item.nombres))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(items.item.fecha_emision))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(items.item.fecha_desde))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(items.item.fecha_retorno))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(items.item.tipo_permiso))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(items.item.estado_permiso))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(items.item.horas_permiso))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      items.item.id_tipo_permiso == 90
                                        ? items.item.motivo
                                        : "Otros"
                                    ) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              !items.item.nro_dias
                                ? _c("td", [_vm._v("0")])
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.nro_dias
                                ? _c("td", [
                                    _vm._v(_vm._s(items.item.nro_dias))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      items.item.id_estado == 7
                                        ? items.item.nombres
                                        : _vm.$storage.get("user").nombres +
                                            " " +
                                            _vm.$storage.get("user")
                                              .ap_paterno +
                                            " " +
                                            _vm.$storage.get("user").ap_materno
                                    ) +
                                    "\n          "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(items.item.justificacion))
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "info",
                                        icon: "",
                                        title: "Ver permiso"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.verPermisoJefe(items.item)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("remove_red_eye")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  (items.item.id_estado == 6 ||
                                    items.item.id_estado == 21) &&
                                  (items.item.id_tipo_permiso == 24 ||
                                    items.item.id_tipo_permiso == 45 ||
                                    items.item.id_tipo_permiso == 45 ||
                                    items.item.id_tipo_permiso == 6 ||
                                    items.item.id_tipo_permiso == 61 ||
                                    items.item.id_tipo_permiso == 12 ||
                                    items.item.id_tipo_permiso == 14)
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "success",
                                            icon: "",
                                            title: "Aprobar permiso 1"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.aprobarPermisoOficialPorHoras(
                                                items.item
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("done")])],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (items.item.id_estado == 6 ||
                                    items.item.id_estado == 21) &&
                                  (items.item.id_tipo_permiso == 24 ||
                                    items.item.id_tipo_permiso == 45 ||
                                    items.item.id_tipo_permiso == 45 ||
                                    items.item.id_tipo_permiso == 6 ||
                                    items.item.id_tipo_permiso == 61 ||
                                    items.item.id_tipo_permiso == 12 ||
                                    items.item.id_tipo_permiso == 14)
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "#E61C5B",
                                            icon: "",
                                            dark: "",
                                            title: "Rechazar permiso"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.rechazarPermisoOficialPorHoras(
                                                items.item
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("close")])],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (items.item.id_estado == 6 ||
                                    items.item.id_estado == 7) &&
                                  items.item.estado_permiso !=
                                    "Aprobada Superior Jerárquico" &&
                                  items.item.estado_permiso !=
                                    "Aprobada Inmediato Superior" &&
                                  items.item.id_tipo_permiso != 24 &&
                                  items.item.id_tipo_permiso != 45 &&
                                  items.item.id_tipo_permiso != 45 &&
                                  items.item.id_tipo_permiso != 6 &&
                                  items.item.id_tipo_permiso != 61 &&
                                  items.item.id_tipo_permiso != 12 &&
                                  items.item.id_tipo_permiso != 14
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "success",
                                            icon: "",
                                            title: "Aprobar permiso2"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.aprobarPermisoOficialPorHoras(
                                                items.item
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("done")])],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (items.item.id_estado == 6 ||
                                    items.item.id_estado == 7) &&
                                  items.item.estado_permiso !=
                                    "Aprobada Superior Jerárquico" &&
                                  items.item.estado_permiso !=
                                    "Aprobada Inmediato Superior" &&
                                  items.item.id_tipo_permiso != 24 &&
                                  items.item.id_tipo_permiso != 45 &&
                                  items.item.id_tipo_permiso != 45 &&
                                  items.item.id_tipo_permiso != 6 &&
                                  items.item.id_tipo_permiso != 61 &&
                                  items.item.id_tipo_permiso != 12 &&
                                  items.item.id_tipo_permiso != 14
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "#E61C5B",
                                            icon: "",
                                            title: "Rechazar permiso"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.rechazarPermisoOficialPorHoras(
                                                items.item
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("close")])],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  items.item.ruta_archivo
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "info",
                                            title: "Ver documento",
                                            icon: ""
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.verDocumento(
                                                items.item
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("attach_file")])],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2430605307
                    )
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-749a8217", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749a8217","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/PermisoDirectorAprobacion.vue
// module id = null
// module chunks = 